import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { HealthScorePanel } from "../components/HealthScorePanel";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import {
  enterpriseOverviewQueryOptions,
  useGetEnterpriseOverview,
} from "../queries/useGetEnterpriseOverview";
import { healthScoreQueryOptions } from "../queries/useGetHealthScore";

function MaturityRouteComponent() {
  const { t } = useTranslation();
  const { externalCustomerId } = Route.useSearch();
  if (!externalCustomerId) {
    return (
      <EnterpriseCustomerSelectionCard
        description={t("enterprise.routes.maturity.selectCustomerDescription")}
      />
    );
  }

  return <MaturityRouteContent externalCustomerId={externalCustomerId} />;
}

function MaturityRouteContent({
  externalCustomerId,
}: {
  externalCustomerId: string;
}) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data } = useGetEnterpriseOverview(customer.customerId);

  return (
    <HealthScorePanel
      customerId={customer.customerId}
      customerName={data.customer.customerName}
    />
  );
}

export const Route = createFileRoute("/_app/maturity")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }
    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );
    await Promise.all([
      context.queryClient.ensureQueryData(
        enterpriseOverviewQueryOptions(customer.customerId),
      ),
      context.queryClient.ensureQueryData(
        healthScoreQueryOptions(customer.customerId),
      ),
    ]);
  },
  component: MaturityRouteComponent,
});
